import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import '../portal/application.scss';
import Vue from 'vue';
import { InitializationHelpers } from '../portal/portalHelpers';
import {
  maybeShowEditArticleButton,
  maybeExpandRelatedPortals,
} from '../portal/authCheck';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { domPurifyConfig } from '../shared/helpers/HTMLSanitizer';
import { directive as onClickaway } from 'vue-clickaway';
import { IFrameHelper } from '../sdk/IFrameHelper';

Vue.use(VueDOMPurifyHTML, domPurifyConfig);
Vue.directive('on-clickaway', onClickaway);

Rails.start();
Turbolinks.start();

document.addEventListener('turbolinks:load', () => {
  InitializationHelpers.onLoad();
  maybeShowEditArticleButton();
  maybeExpandRelatedPortals();
});

document.addEventListener('turbolinks:before-render', event => {
  const newBody = event.data?.newBody || document.body;
  const newToken = newBody.dataset?.portalWidgetToken || '';
  const currentToken = window.$cloudchat?.websiteToken || '';

  // If destination portal has no widget, remove current
  if (!newToken && window.$cloudchat) {
    IFrameHelper.destroy();
  }

  // If destination has different widget, cleanup to allow re-init
  if (newToken && currentToken && newToken !== currentToken) {
    IFrameHelper.destroy();
  }
});

window.addEventListener("cloudchat:ready", function () {
  console.log('Cloudchat ready event received in portal layout');
  if (!window.cloudchatMoved) {
    var elements = [
      "cw-bubble-holder",
      "cw-widget-holder",
      "cw-widget-styles",
    ];
    const parent = document.getElementById("permanent-holder");
    elements.forEach(function (elementId) {
      var el = document.getElementById(elementId);
      if (el && parent) {
        parent.appendChild(el);
      }
    });
    window.cloudchatMoved = true;
  }

  IFrameHelper.sendMessage('toggle-open', { isOpen: true });
});
